import StardriftQuiz from './StardriftQuiz';
export default StardriftQuiz;
